import React from 'react'
import {useHistory} from 'react-router-dom'

import bottom from './img/bottom.png'
import logo from './img/logo.png'

import './page.css'

const Page = ({children, className = ''}) => {
    const history = useHistory()

    return (
        <div className={`page ${className}`}>
            <div
                className="page__logo"
                onClick={() => {
                    history.push('/ge/')
                }}
            >
                <img className="page__logo_img" src={logo} alt="logo" />
            </div>
            <div className="page__content">{children}</div>
            <div className="page__bg--top" />
            <div className="page__bg--bottom">
                <img src={bottom} alt="moon" className="page__bg--bottom_img" />
            </div>
        </div>
    )
}

export default Page
